import React, { useEffect, useState } from 'react';

import {
	Alert,
	Box,
	Button,
	CircularProgress,
	FormHelperText,
	Grid,
	Input,
	InputAdornment,
	Modal,
	Snackbar,
	TextField,
	Tooltip,
	tooltipClasses,
	Typography,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Popper from '@mui/material/Popper';

import IconButton from '@mui/material/IconButton';

import pencilICON from '../../../../../assets/logos/pencil_Icon_EDITCPT.png';
import delete_Icon from '../../../../../assets/logos/delete_Icon.png';

import CloseIcon from '@mui/icons-material/Close';

import CancelIcon from '@mui/icons-material/Cancel';

import BrandedLoader from '../../../../components/BrandedLoader/BrandedLoader';

import {
	Add,
	ArrowDropDown,
	ArrowDropUp,
	Delete,
	DeleteOutline,
	EditOutlined,
	ExpandLess,
	ExpandMore,
	ListAltOutlined,
	Minimize,
	Search,
} from '@mui/icons-material';
import {
	getDxCodes,
	getDxCodesId,
	getUserSettings,
	postUserSettings,
	updateUserSettings,
} from '../../../../services/api/apiManager';
import styled from 'styled-components';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(900px, calc(100vw - 32px))',
	backgroundColor: '#fff',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

const modalButtonSx = {
	height: '40px',
	borderRadius: '6px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
};

const outlineButtonSx = {
	...modalButtonSx,
	minWidth: '112px',
	border: '1px solid #cfd9e8',
	backgroundColor: '#fff',
	color: '#344054',
	'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
};

const primaryButtonSx = {
	...modalButtonSx,
	minWidth: '122px',
	backgroundColor: '#2f6edb',
	color: '#fff',
	boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
	'&:hover': { backgroundColor: '#245fc5' },
	'&.Mui-disabled': {
		backgroundColor: '#d7dce5',
		color: '#98a2b3',
		boxShadow: 'none',
	},
};

function CustomizeDX() {
	const defaultTheme = createTheme();
	const practiceID = localStorage.getItem('practice_id');
	const [openSnackbar, setOpenSnackbar] = useState({
		open: false,
		snackbarFor: '',
	});
	const [loading, setLoading] = useState(false);
	const [openModal, setOpenModal] = useState({ open: false, modalFor: '' });
	const [deleteModal, setdeleteModal] = useState({
		open: false,
		settingName: '',
	});
	const [editSettingNameModal, setEditSettingNameModal] = useState(false);
	const [wrapCodes, setWrapCodes] = useState(null);
	const [modalWrapCodes, setModalWrapCodes] = useState(null);
	const [modalLoading, setModalLoading] = useState(false);
	const [addListAnchorEl, setAddListAnchorEl] = useState(null);
	const [addSettingName, setAddSettingName] = useState(''); // I'm using this same state for adding name of custom-setting and also for updating name of  custom-setting as well

	const [selectedSettingId, setSelectedSettingId] = useState(0);
	const [userSettingsList, setUserSettingsList] = useState([]);
	const [nestedWrapCodes, setNestedWrapCodes] = useState([]);
	const [ICDCodeAll, setICDCodesAll] = useState([]);
	const [ICDWithID, setICDWithID] = useState([]);
	const [selectedICDCodes, setSelectedICDCodes] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [searchFilter, setSearchFilter] = useState([]);

	const handleOpenAddList = (event) => {
		setAddListAnchorEl((prevaAnchorEl) =>
			prevaAnchorEl ? null : event.currentTarget
		);
	};
	const searchFilterHanlder = (event) => {
		setSearchText(event.target.value);
	};
	// filter ICD
	const afterFilteration = searchFilter?.filter((items) => {
		return (
			items?.MinCode?.toLowerCase()?.includes(searchText.toLowerCase()) ||
			items?.MaxCode?.toLowerCase()?.includes(searchText.toLowerCase()) ||
			items?.Name?.toLowerCase()?.includes(searchText.toLowerCase())
		);
	});

	// function for aading new User Settings Name
	const addUserSetting = async (data) => {
		const resp = await postUserSettings(data);
		if (resp?.status === 201) {
			getUserSetting();
			setOpenSnackbar({ open: true, snackbarFor: 'newListAdded' });
			setAddSettingName('');
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};
	const getUserSetting = async () => {
		setLoading(true);
		try {
			const resp = await getUserSettings();
			if (resp?.status === 200) {
				setUserSettingsList(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'ICD' || items?.Type === 'icd')
							);
						})
						?.reverse()
				);
				// setNestedWrapCodes(
				// 	resp?.data?.map((items) => items?.setting_codes).reverse()
				// );
				setLoading(false);
			} else {
				setUserSettingsList([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};
	const getDxCodesAll = async () => {
		const resp = await getDxCodes();
		if (resp?.status === 200) {
			setICDCodesAll(resp?.data);
			setSearchFilter(resp?.data);
		} else {
			setICDCodesAll([]);
		}
	};
	const getICDCodeWithID = async (id) => {
		setModalLoading(true);
		const resp = await getDxCodesId(id);
		if (resp?.status === 200) {
			setModalLoading(false);
			setICDWithID(resp?.data);
		} else {
			setICDWithID([]);
		}
	};

	const updateUserSetting = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setAddSettingName('');
			getUserSetting();
			if (resp?.data?.Deleted) {
				setOpenSnackbar({ open: true, snackbarFor: 'listDeleted' });
			} else {
				setOpenSnackbar({ open: true, snackbarFor: 'listUpdated' });
			}
			setSelectedICDCodes([]);
			setWrapCodes(null);
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};
	const deleteNestedWrapCodes = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setOpenSnackbar({ open: true, snackbarFor: 'listDeleted' });
			//for getting all user setting details I can call getUserSetting()  function again here but there was loader in it and i dont want that loader
			const resp = await getUserSettings();
			setUserSettingsList(
				resp?.data
					?.filter((items) => {
						return (
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'ICD' || items?.Type === 'icd')
						);
					})
					?.reverse()
			);
			setSelectedICDCodes([]);
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};

	// this function get all the selected codes of the a particular setting according to their id
	const wrapCodesAccordingtoSettingID = (id) => {
		userSettingsList
			?.map((items) => items?.setting_codes)
			?.forEach((wrap) => {
				if (
					wrap.filter(
						(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
					).length > 0
				) {
					setNestedWrapCodes(
						wrap.filter(
							(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
						)
					);
					setSelectedICDCodes(
						wrap.filter(
							(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
						)
					);
				}
			});
	};
	useEffect(() => {
		getUserSetting();
		getDxCodesAll();
	}, []);
	return (
		<ThemeProvider theme={defaultTheme}>
			{loading ? ( // Display loading indicator if loading is true
				<BrandedLoader
					title="Loading diagnosis settings"
					text="Preparing customization options"
				/>
			) : (
				<>
					<Box
						sx={{
							width: '100%',
							minHeight: 'calc(100vh - 170px)',
							background: '#f5f8fc',
							border: '1px solid #e3edf8',
							borderRadius: '8px',
							p: 2,
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: { xs: 'flex-start', sm: 'center' },
								gap: 2,
								mb: 2.5,
								flexDirection: { xs: 'column', sm: 'row' },
							}}
						>
							<Box>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '20px',
										color: '#0b2450',
										lineHeight: 1.2,
									}}
								>
									{`All Custom ICD's List`}
								</Typography>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										color: '#64748b',
										mt: 0.6,
									}}
								>
									View, manage and organize all your custom ICD lists.
								</Typography>
							</Box>
							<Button
								variant="contained"
								onClick={handleOpenAddList}
								aria-describedby={'add-list-popper'}
								startIcon={<Add sx={{ fontSize: '18px' }} />}
								sx={{
									minWidth: '110px',
									height: '38px',
									bgcolor: '#2f6edb',
									borderRadius: '6px',
									color: '#FFFFFF',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									'&:hover': { background: '#245fc5' },
								}}
							>
								Add List
							</Button>

							<Popper
								sx={{ zIndex: 9 }}
								id={'add-list-popper'}
								open={addListAnchorEl}
								anchorEl={addListAnchorEl}
							>
								<Box
									sx={{
										width: 290,
										borderRadius: '8px',
										boxShadow: '0 12px 28px rgba(15, 23, 42, 0.16)',
										p: 1.5,
										background: '#FFFFFF',
										border: '1px solid #dce8f5',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											mb: 1,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: 700,
												color: '#0b2450',
											}}
										>
											Add List Name
										</Typography>
										<IconButton
											onClick={() => {
												setAddListAnchorEl(null);
											}}
											aria-describedby={'add-list-popper'}
											size="small"
											sx={{ color: '#64748b' }}
										>
											<CloseIcon sx={{ fontSize: '18px' }} />
										</IconButton>
									</Box>
									<Input
										id="settingNameField"
										disableUnderline
										type="text"
										fullWidth
										value={addSettingName}
										onChange={(e) => setAddSettingName(e.target.value)}
										placeholder="Enter list name"
										sx={{
											height: '40px',
											borderRadius: '6px',
											border: '1px solid #d7e3f4',
											px: 1.3,
											mb: 0.8,
											fontFamily: 'Poppins',
											fontSize: '13px',
											color: '#0b2450',
										}}
									/>
									{addSettingName === '' && (
										<FormHelperText
											sx={{ color: '#ef4444', fontFamily: 'Poppins', fontSize: '11px', mb: 1 }}
										>{`Name shouldn't be Empty`}</FormHelperText>
									)}
									<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
										<Button
											disabled={addSettingName === ''}
											onClick={() => {
												setAddListAnchorEl(null);
												setSelectedICDCodes([]);
												setOpenModal({ open: true, modalFor: 'addFirstTime' });
											}}
											sx={{
												minWidth: '92px',
												height: '36px',
												bgcolor: '#2f6edb',
												borderRadius: '6px',
												color: '#FFFFFF',
												fontFamily: 'Poppins',
												fontSize: '13px',
												fontWeight: 700,
												textTransform: 'none',
												'&:hover': { background: '#245fc5' },
												'&.Mui-disabled': {
													backgroundColor: '#d7dce5',
													color: '#98a2b3',
												},
											}}
										>
											Proceed
										</Button>
									</Box>
								</Box>
							</Popper>
						</Box>
						<Box
							sx={{
								background: '#fff',
								border: '1px solid #e3edf8',
								borderRadius: '8px',
								p: 1.8,
								maxHeight: 'calc(100vh - 265px)',
								overflow: 'auto',
							}}
						>
							{userSettingsList.length === 0 && (
								<Box
									sx={{
										width: '100%',
										minHeight: '140px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										color: '#64748b',
										fontFamily: 'Poppins',
										fontSize: '13px',
									}}
								>
									0 Record
								</Box>
							)}
							{userSettingsList?.map((items) => {
								const isExpanded = wrapCodes === items?.id;
								return (
									<Box
										key={items?.id}
										sx={{
											border: '1px solid #e3edf8',
											borderRadius: '8px',
											mb: 1.2,
											background: '#fff',
											boxShadow: '0 3px 10px rgba(15, 23, 42, 0.06)',
											overflow: 'hidden',
										}}
									>
										<Box
											sx={{
												minHeight: 42,
												display: 'flex',
												alignItems: 'center',
												gap: 1.4,
												px: 1.2,
											}}
										>
											<Box
												sx={{
													width: 28,
													height: 28,
													borderRadius: '50%',
													bgcolor: '#eef4ff',
													color: '#2f6edb',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													flex: '0 0 auto',
												}}
											>
												<ListAltOutlined sx={{ fontSize: '16px' }} />
											</Box>
											<Typography
												sx={{
													fontFamily: 'Poppins',
													fontSize: '13px',
													fontWeight: 700,
													color: '#19365f',
													flex: 1,
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
												}}
											>
												{items?.SettingName}
											</Typography>
											<IconButton
												size="small"
												onClick={() => {
													if (isExpanded) {
														setWrapCodes(null);
														return;
													}
													setWrapCodes(items?.id);
													if (items?.setting_codes?.length > 0) {
														wrapCodesAccordingtoSettingID(
															items?.setting_codes?.map((code) => code?.setting_id)
														);
													} else {
														setNestedWrapCodes([]);
														setSelectedICDCodes([]);
													}
												}}
												sx={{ color: '#3f5f91', mr: 1 }}
											>
												{isExpanded ? <ExpandLess /> : <ExpandMore />}
											</IconButton>
											<Tooltip title="Add More Codes">
												<IconButton
													onClick={() => {
														if (items?.setting_codes?.length > 0) {
															wrapCodesAccordingtoSettingID(
																items?.setting_codes?.map((code) => code?.setting_id)
															);
														} else {
															setNestedWrapCodes([]);
															setSelectedICDCodes([]);
														}
														setOpenModal({
															open: true,
															modalFor: 'addMore',
														});
														setSelectedSettingId(items?.id);
													}}
													sx={{
														width: 32,
														height: 32,
														borderRadius: '6px',
														bgcolor: '#2bb45a',
														color: '#fff',
														mr: 0.6,
														'&:hover': { bgcolor: '#22984b' },
													}}
												>
													<Add sx={{ fontSize: '18px' }} />
												</IconButton>
											</Tooltip>
											<Tooltip title="Edit List Name">
												<IconButton
													onClick={() => {
														setSelectedSettingId(items?.id);
														setAddSettingName(items?.SettingName);
														setEditSettingNameModal(true);
													}}
													sx={{
														width: 32,
														height: 32,
														borderRadius: '6px',
														bgcolor: '#1d60c5',
														color: '#fff',
														mr: 0.6,
														'&:hover': { bgcolor: '#164fa5' },
													}}
												>
													<EditOutlined sx={{ fontSize: '17px' }} />
												</IconButton>
											</Tooltip>
											<Tooltip title="Delete List">
												<IconButton
													onClick={() => {
														setSelectedSettingId(items?.id);
														setdeleteModal({
															open: true,
															settingName: items?.SettingName,
														});
													}}
													sx={{
														width: 32,
														height: 32,
														borderRadius: '6px',
														bgcolor: '#ef4444',
														color: '#fff',
														'&:hover': { bgcolor: '#dc2626' },
													}}
												>
													<DeleteOutline sx={{ fontSize: '18px' }} />
												</IconButton>
											</Tooltip>
										</Box>
										{isExpanded && (
											<Box
												sx={{
													borderTop: '1px solid #e3edf8',
													background: '#f7fbff',
													px: 2,
													py: 1.2,
												}}
											>
												{nestedWrapCodes?.length === 0 ? (
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '12px',
															color: '#64748b',
														}}
													>
														No items added yet.
													</Typography>
												) : (
													nestedWrapCodes?.map((nestedItems) => (
														<Box
															key={nestedItems?.id}
															sx={{
																display: 'grid',
																gridTemplateColumns: '90px 1fr 32px',
																alignItems: 'center',
																gap: 1,
																minHeight: 36,
																borderBottom: '1px solid #e6eef8',
																'&:last-child': { borderBottom: 0 },
															}}
														>
															<Typography
																sx={{
																	color: '#1d60c5',
																	fontSize: '13px',
																	fontFamily: 'Poppins',
																	fontWeight: 700,
																}}
															>
																{nestedItems?.Code}
															</Typography>
															<CustomWidthTooltip
																arrow
																title={`(${nestedItems?.Code}) ${nestedItems?.CodeDescription}`}
																placement="top-start"
															>
																<Typography
																	sx={{
																		color: '#2e476b',
																		fontSize: '12px',
																		fontFamily: 'Poppins',
																		fontWeight: 400,
																		overflow: 'hidden',
																		textOverflow: 'ellipsis',
																		whiteSpace: 'nowrap',
																	}}
																>
																	{nestedItems?.CodeDescription}
																</Typography>
															</CustomWidthTooltip>
															<IconButton
																size="small"
																onClick={() => {
																	const afterDeletion = nestedWrapCodes?.filter(
																		(code) => code?.id !== nestedItems.id
																	);

																	setNestedWrapCodes(afterDeletion);

																	deleteNestedWrapCodes(items?.id, {
																		setting_codes: afterDeletion,
																	});
																}}
																sx={{ color: '#ef4444' }}
															>
																<Delete sx={{ fontSize: '18px' }} />
															</IconButton>
														</Box>
													))
												)}
											</Box>
										)}
									</Box>
								);
							})}
						</Box>
					</Box>
				</>
			)}

			{/* I am using this same modal for creating the setting and also for updating the setting_codes when they added  */}
			<Modal
				open={openModal.open}
				onClose={() => {
					setOpenModal({ open: false, modalFor: '' });
					setAddSettingName('');
					setModalWrapCodes(null);
					setSelectedICDCodes([]);
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={style}>
					<Grid
						position={'sticky'}
						top={0}
						left={0}
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						justifyContent="center"
					>
						<Box
							sx={{
								bgcolor: '#fff',
								width: '100%',
								height: '60px',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								borderBottom: '1px solid #edf2f8',
								px: 2,
							}}
						>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontSize: '20px',
									fontWeight: 700,
									color: '#111827',
								}}
							>
								Select ICDs
							</Typography>
							<IconButton
								onClick={() => {
									setOpenModal({ open: false, modalFor: '' });
									setAddSettingName('');
									setModalWrapCodes(null);
									setSelectedICDCodes([]);
								}}
								sx={{ color: '#475569' }}
							>
								<CloseIcon sx={{ fontSize: '22px' }} />
							</IconButton>
						</Box>
						<Box
							width={'100%'}
							height={'58px'}
							bgcolor={'#fff'}
							borderBottom={'1px solid #edf2f8'}
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							px={2}
						>
							<TextField
								variant="outlined"
								size="small"
								type="text"
								id="searchICD"
								value={searchText}
								onChange={(event) => {
									searchFilterHanlder(event);
								}}
								sx={{
									width: '100%',
									maxWidth: '520px',
									bgcolor: '#FFFFFF',
									'& .MuiOutlinedInput-root': {
										height: '40px',
										borderRadius: '6px',
										fontFamily: 'Poppins',
										fontSize: '13px',
										color: '#0b2450',
										'& fieldset': { borderColor: '#d7e3f4' },
										'&:hover fieldset': { borderColor: '#b8c9e0' },
										'&.Mui-focused fieldset': { borderColor: '#2f6edb', borderWidth: '1px' },
									},
									'& .MuiInputBase-input': {
										padding: '9px 12px',
									},
								}}
								placeholder="Search ICD code or description..."
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Search sx={{ fontSize: '18px', color: '#71839f' }} />
										</InputAdornment>
									),
								}}
							/>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						height={'min(52vh, 440px)'}
						overflow={'auto'}
						sx={{ px: 2, py: 1.5, bgcolor: '#f8fbff' }}
					>
						{/*(inside of MODAL) code For add More Codes - that we wants to add in our particular setting */}
						{afterFilteration.length === 0 && (
							<Box
								width={'100%'}
								display={'flex'}
								justifyContent={'center'}
								color={'red'}
								mt={1}
							>
								No Match Found
							</Box>
						)}
						{afterFilteration?.map((items, index) => {
							return (
								<>
									<Grid
										key={index}
										container
										justifyContent={'space-between'}
										alignItems={'center'}
										minHeight={'42px'}
										bgcolor={'#FFFFFF'}
										sx={{
											border: '1px solid #e3edf8',
											borderRadius: '6px',
											mb: 0.8,
											px: 1.2,
										}}
									>
										<Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
											<Typography
												color={'#1D60C5'}
												// fontSize={'15px'}
												fontFamily={'Poppins'}
												fontWeight={600}
												sx={{
													fontSize: {
														xl: '15px',
														lg: '15px',
														md: '14px',
														sm: '12px',
														xs: '9px',
													},
													whiteSpace: 'nowrap',
												}}
											>
												{items?.MinCode} - {items?.MaxCode}
											</Typography>
										</Grid>
										<Grid item xs={8.2} sm={8.2} md={8.2} lg={8.2} xl={8.2}>
											<Typography
												color={'#2E476B'}
												// fontSize={'14px'}
												fontFamily={'Poppins'}
												fontWeight={400}
												sx={{
													fontSize: {
														xl: '13px',
														lg: '13px',
														md: '13px',
														sm: '11px',
														xs: '9px',
													},
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
												}}
											>
												{items?.Name}
											</Typography>
										</Grid>
										<Grid
											item
											xs={0.5}
											sm={0.5}
											md={0.5}
											lg={0.5}
											xl={0.5}
											display={'flex'}
											alignItems={'center'}
										>
											{modalWrapCodes === null ||
											modalWrapCodes !== items?.id ? (
												<Add
													onClick={() => {
														setModalWrapCodes(items?.id);
														getICDCodeWithID(items?.id);
													}}
													sx={{
														color: '#1D60C5',
														cursor: 'pointer',
														fontSize: '22px',
													}}
												/>
											) : (
												<Minimize
													onClick={() => {
														setModalWrapCodes(null);
													}}
													sx={{
														color: '#1D60C5',
														cursor: 'pointer',
														fontSize: '22px',
														marginTop: '-12px',
													}}
												/>
											)}
										</Grid>
									</Grid>
									{modalWrapCodes == items?.id && modalLoading && (
										<Box
											width={'100%'}
											height={'10vh'}
											display={'flex'}
											justifyContent={'center'}
											alignItems={'center'}
										>
											{' '}
											<CircularProgress />
										</Box>
									)}

									{modalWrapCodes == items?.id &&
										ICDWithID?.map((nestedItems, nestedIndex) => {
											{
												/* (inside of MODAL) show more codes Box is here on the Add icon */
											}
											return (
												!modalLoading && (
													<Grid
														key={nestedIndex}
														container
														justifyContent={'space-evenly'}
														borderBottom={'1px solid #e3edf8'}
														alignItems={'center'}
														minHeight={'34px'}
														bgcolor={'#FFFFFF'}
													>
														<Grid
															item
															xs={2}
															sm={2}
															md={2}
															lg={2}
															xl={2}
															display={'flex'}
															height={'33px'}
															alignItems={'center'}
															gap={0.4}
														>
															<input
																checked={
																	selectedICDCodes.filter(
																		(items) => items.Code == nestedItems.Code
																	)[0]?.Code !== undefined &&
																	selectedICDCodes.filter(
																		(items) => items.Code == nestedItems.Code
																	)[0]?.Code
																}
																value={nestedItems?.Code}
																onChange={(event) => {
																	if (event.target.checked) {
																		setSelectedICDCodes((prev) => [
																			...prev,
																			{
																				setting_id: selectedSettingId,
																				CodeType: 'ICD',
																				Code: event.target.value,
																				CodeDescription:
																					nestedItems?.Description,
																			},
																		]);
																	} else {
																		const removeCodes = selectedICDCodes.filter(
																			(items) =>
																				items?.Code !== event.target.value
																		);
																		setSelectedICDCodes(removeCodes);
																	}
																}}
																type="checkbox"
																id={nestedItems?.Code}
																style={{ cursor: 'pointer', width: '25px' }}
															></input>
															<label
																htmlFor={nestedItems?.Code}
																style={{
																	color: '#1D60C5',
																	fontSize: '10px',
																	fontWeight: 600,
																	fontFamily: 'Poppins',
																}}
															>
																{nestedItems?.Code}
															</label>
														</Grid>
														<CustomWidthTooltip
															arrow
															title={`(${nestedItems?.Code}) ${nestedItems?.Description}`}
															placement="top-start"
														>
															<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																<Typography
																	color={'#2E476B'}
																	// fontSize={'14px'}
																	fontFamily={'Poppins'}
																	fontWeight={400}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '14px',
																			md: '13px',
																			sm: '11px',
																			xs: '8px',
																		},
																	}}
																>
																	{(nestedItems?.Description).slice(0, 55)}...
																</Typography>
															</Grid>
														</CustomWidthTooltip>
													</Grid>
												)
											);
										})}
								</>
							);
						})}
					</Grid>

					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						gap={1.5}
						sx={{
							borderTop: '1px solid #edf2f8',
							bgcolor: '#fff',
							px: 2,
							py: 1.5,
						}}
					>
						<Button
							onClick={() => {
								setOpenModal({ open: false, modalFor: '' });
								setModalWrapCodes(null);
								setSelectedICDCodes([]);
								setAddSettingName('');
							}}
							startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
							sx={outlineButtonSx}
						>
							Cancel
						</Button>
						{openModal.modalFor === 'addFirstTime' ? (
							<Button
								startIcon={<Add sx={{ fontSize: '18px' }} />}
								sx={primaryButtonSx}
								onClick={() => {
									addUserSetting({
										practice_id: practiceID,
										Type: 'ICD',
										SettingName: addSettingName,
										setting_codes: selectedICDCodes,
									});
									setAddSettingName('');
									setOpenModal({ open: false, modalFor: '' });
									setSelectedICDCodes([]);
								}}
							>
								Add New
							</Button>
						) : (
							<Button
								startIcon={<Add sx={{ fontSize: '18px' }} />}
								sx={primaryButtonSx}
								onClick={() => {
									updateUserSetting(selectedSettingId, {
										setting_codes: selectedICDCodes,
									});
									setOpenModal({ open: false, modalFor: '' });
									setSelectedICDCodes([]);
									setAddSettingName('');
								}}
							>
								Add More
							</Button>
						)}
					</Box>
				</Box>
			</Modal>

			{/* delete modal is here */}
			<Modal
				open={deleteModal?.open}
				onClose={() => {
					setdeleteModal({ open: false });
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={{ ...style, width: 'min(410px, calc(100vw - 32px))', overflow: 'hidden' }}>
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '12px 12px 0' }}>
						<IconButton
							size="small"
							onClick={() => {
								setdeleteModal({ open: false });
							}}
							sx={{ width: 32, height: 32, color: '#64748b' }}
						>
							<CloseIcon sx={{ fontSize: '20px' }} />
						</IconButton>
					</Box>
					<Box sx={{ px: 3, pt: 1, pb: 3, textAlign: 'center' }}>
						<Box
							sx={{
								width: 74,
								height: 74,
								borderRadius: '50%',
								background: '#fff1f2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mx: 'auto',
								mb: 2,
							}}
						>
							<Box
								sx={{
									width: 52,
									height: 52,
									borderRadius: '50%',
									background: '#ffe4e6',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DeleteOutline sx={{ color: '#ef4444', fontSize: '30px' }} />
							</Box>
						</Box>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 500,
								fontSize: '15px',
								color: '#1f2937',
								mb: 1,
							}}
						>
							Are you sure you want to delete this custom ICD list?
						</Typography>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#005eff',
								lineHeight: 1.45,
								wordBreak: 'break-word',
							}}
						>
							{deleteModal?.settingName}
						</Typography>
					</Box>
					<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, px: 3, py: 2.5, borderTop: '1px solid #edf2f8' }}>
						<Button
							onClick={() => {
								setdeleteModal({ open: false });
							}}
							startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
							sx={{
								...outlineButtonSx,
								minWidth: 0,
								color: '#ef4444',
								'&:hover': { background: '#fff5f5', borderColor: '#fecaca' },
							}}
						>
							No
						</Button>
						<Button
							startIcon={<DeleteOutline sx={{ fontSize: '18px' }} />}
							sx={{ ...primaryButtonSx, minWidth: 0 }}
							onClick={() => {
								updateUserSetting(selectedSettingId, {
									Deleted: true,
								});
								setdeleteModal({ open: false });
							}}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal>
			{/* edit setting name modal is here */}
			<Modal
				open={editSettingNameModal}
				onClose={() => {
					setEditSettingNameModal(false);
					setAddSettingName('');
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box
					sx={{
						...style,
						width: 'min(520px, calc(100vw - 32px))',
					}}
				>
					<Box
						sx={{
							height: '60px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							borderBottom: '1px solid #edf2f8',
							px: 2,
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '20px',
								fontWeight: 700,
								color: '#111827',
							}}
						>
							Rename Custom List
						</Typography>
						<IconButton
							onClick={() => {
								setEditSettingNameModal(false);
								setAddSettingName('');
							}}
							sx={{ color: '#475569' }}
						>
							<CloseIcon sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>
					<Box sx={{ width: '100%', p: 2.4 }}>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 600,
								color: '#0b2450',
								mb: 0.8,
							}}
						>
							List Name
						</Typography>
						<Input
							id="settingNameField"
							disableUnderline
							type="text"
							fullWidth
							value={addSettingName}
							onChange={(e) => setAddSettingName(e.target.value)}
							placeholder="Enter Name"
							sx={{
								height: '42px',
								fontFamily: 'Poppins',
								fontSize: '13px',
								color: '#0b2450',
								borderRadius: '6px',
								border: '1px solid #d7e3f4',
								px: 1.3,
								boxSizing: 'border-box',
							}}
						/>
						{addSettingName === '' && (
							<FormHelperText
								sx={{ color: '#ef4444', fontFamily: 'Poppins', fontSize: '11px' }}
							>{`*Name should\'t be Empty`}</FormHelperText>
						)}
					</Box>
					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						gap={1.5}
						sx={{ borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}
					>
						<Button
							onClick={() => {
								setEditSettingNameModal(false);
								setAddSettingName('');
							}}
							startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
							sx={outlineButtonSx}
						>
							Cancel
						</Button>
						<Button
							disabled={addSettingName === '' ? true : false}
							startIcon={<EditOutlined sx={{ fontSize: '18px' }} />}
							sx={primaryButtonSx}
							onClick={() => {
								updateUserSetting(selectedSettingId, {
									SettingName: addSettingName,
								});
								setEditSettingNameModal(false);
							}}
						>
							Rename
						</Button>
					</Box>
				</Box>
			</Modal>

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar.open}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={() => setOpenSnackbar({ open: false })}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={() => setOpenSnackbar({ open: false, snackbarFor: '' })}
					severity={openSnackbar.snackbarFor === 'error' ? 'error' : 'success'}
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					{openSnackbar.snackbarFor === 'listUpdated'
						? ` Updated Successfully!`
						: openSnackbar.snackbarFor === 'newListAdded'
							? 'Custom-ICD List Added Successfully!'
							: openSnackbar.snackbarFor === 'listDeleted'
								? 'Deleted SuccessFully'
								: openSnackbar.snackbarFor === 'error'
									? 'ERROR!'
									: ''}
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default CustomizeDX;
// our custom tooltip styling code is here
const CustomWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
		backgroundColor: 'gray',
		fontSize: '12px',
	},
});

